import { useCallback } from "react";

declare global {
  interface Window {
    grecaptcha: any;
  }
}

export const useRecaptcha = () => {
  const executeRecaptcha = useCallback(async (action: string) => {
    if (!window.grecaptcha?.enterprise) {
      throw new Error("Google reCAPTCHA Enterprise is not loaded.");
    }

    return await window.grecaptcha.enterprise.execute(
      process.env.REACT_APP_RECAPTCHA_SITE_KEY!,
      { action },
    );
  }, []);

  return { executeRecaptcha };
};
